var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 8.66602C8.36811 8.66602 8.66659 8.36754 8.66659 7.99935C8.66659 7.63116 8.36811 7.33268 7.99992 7.33268C7.63173 7.33268 7.33325 7.63116 7.33325 7.99935C7.33325 8.36754 7.63173 8.66602 7.99992 8.66602Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 3.99935C8.36811 3.99935 8.66659 3.70087 8.66659 3.33268C8.66659 2.96449 8.36811 2.66602 7.99992 2.66602C7.63173 2.66602 7.33325 2.96449 7.33325 3.33268C7.33325 3.70087 7.63173 3.99935 7.99992 3.99935Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 13.3327C8.36811 13.3327 8.66659 13.0342 8.66659 12.666C8.66659 12.2978 8.36811 11.9993 7.99992 11.9993C7.63173 11.9993 7.33325 12.2978 7.33325 12.666C7.33325 13.0342 7.63173 13.3327 7.99992 13.3327Z",
    fill: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 8.66602C8.36811 8.66602 8.66659 8.36754 8.66659 7.99935C8.66659 7.63116 8.36811 7.33268 7.99992 7.33268C7.63173 7.33268 7.33325 7.63116 7.33325 7.99935C7.33325 8.36754 7.63173 8.66602 7.99992 8.66602Z",
    stroke: "#737373",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 3.99935C8.36811 3.99935 8.66659 3.70087 8.66659 3.33268C8.66659 2.96449 8.36811 2.66602 7.99992 2.66602C7.63173 2.66602 7.33325 2.96449 7.33325 3.33268C7.33325 3.70087 7.63173 3.99935 7.99992 3.99935Z",
    stroke: "#737373",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 13.3327C8.36811 13.3327 8.66659 13.0342 8.66659 12.666C8.66659 12.2978 8.36811 11.9993 7.99992 11.9993C7.63173 11.9993 7.33325 12.2978 7.33325 12.666C7.33325 13.0342 7.63173 13.3327 7.99992 13.3327Z",
    stroke: "#737373",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDots);
export default __webpack_public_path__ + "static/media/gray-dots.3a0a7b8c90d4cb24eb44fb4007c89d26.svg";
export { ForwardRef as ReactComponent };